import React, {FC} from "react";
import { Drawer, IconButton, Toolbar} from "@material-ui/core";
import {ReactComponent as ArrowRight} from '../../assets/fontAwesome/arrow-to-right.svg';
import {makeStyles} from "@material-ui/core/styles";
import Trip from './Trip'

import axios from "axios";
import { endpoints } from "../../constants";


const useStyles = makeStyles((theme) => ({
    drawer: {
        width: 350,
        overflow: 'hidden',
    },
    transition: {
        overflow: 'hidden',
        transition: 'all 0.5s ease'
    },
    drawerTop: {
        width: 'calc(100% - 16px)',
        backgroundColor: theme.palette.primary.main,
        borderTop: '1px solid rgba(255, 255, 255, 0.12);',
        color: '#fff',
        paddingLeft: '16px',
        display: 'flex',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        padding: '0'
    },
    drawerTitle: {
        fontSize: '22.5px',
        display: "inline-block",
        whiteSpace: 'nowrap'
    },
    headerTitle: {
        fontSize: '22.5px'
    },
    card: {
        margin: '10px',
        marginBottom: '0',
        padding: '7px',
        cursor: "pointer",
        minHeight: '105px',
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'space-between',
    }
}))

const days = [
    'Zondag',
    'Maandag',
    'Dinsdag',
    'Woensdag',
    'Donderdag',
    'Vrijdag',
    'Zaterdag'
]

const dateConverter = (time: string) => `${days[new Date(time).getDay()]}, ${new Date(time).toLocaleDateString()}`

type Props = {
    tripsDrawerOpen: boolean;
    setTripsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setTrip: React.Dispatch<React.SetStateAction<Array<{lat: number, lng: number}> | null>>;
    trips: any [];
    setGpsLocation: React.Dispatch<React.SetStateAction<{lat: number, lng: number}>>;
    id: string | null;
}


const TripsDrawer: FC<Props> = ({tripsDrawerOpen, setTripsDrawerOpen, setTrip, trips, setGpsLocation, id}) => {
    const classes = useStyles()
    const { backendEndpoint } = endpoints

    const getTrip = async (tripId: string) => {
        axios.get(`${backendEndpoint}/investigations/${id}/trips/${tripId}`).then(res => {
            const waypoints = res.data.data.waypoints
            const tripEnd = waypoints[waypoints.length - 1].position
            setGpsLocation({lat: tripEnd.latitude, lng: tripEnd.longitude})
            const formattedWaypoints = waypoints.map((point: {position: {latitude: number, longitude: number}}) => {
                return {lat: point.position.latitude, lng: point.position.longitude}
                })
            setTrip(formattedWaypoints)
        })
    }

    return (
        <Drawer anchor={'right'} open={tripsDrawerOpen} variant={'persistent'} className={classes.drawer} classes={{paper: classes.drawer}} >
            <div className={`${classes.drawerTop} trips-drawer-margin`}>
                <Toolbar className={classes.toolbar}>
                    <span className={classes.headerTitle}>Trips</span>
                        <IconButton onClick={() => setTripsDrawerOpen(false)}>
                            <ArrowRight fill={"white"} style={{height: '24px', marginRight: '4px'}} />
                        </IconButton>
                </Toolbar>
            </div>
            <div style={{overflowY: 'auto'}}>
                {trips && trips.map((trip: any, index) =>
                        <Trip trip={trip} key={index} index={index} dates={trips.map(trip => dateConverter(trip.started_at))} getTrip={getTrip} />)}
            </div>
        </Drawer>
    )
}

export default TripsDrawer
